import { useMutation } from '@apollo/client';
import { SubmitButton } from '@website/components/forms/fields/SubmitButton';
import {
  AddUserHostRoleInput,
  HostRoleType,
  AddUserHostRoleMutationDocument,
} from '@website/types/graphqlOperations';
import React, { useState } from 'react';
import { Col, Row, Alert, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

interface AddUserHostRoleProps {
  userID: string;
  onRoleAdded: () => void;
}

export default function AddUserHostRole({
  userID,
  onRoleAdded,
}: AddUserHostRoleProps) {
  const [addingHostRolesError, setAddingHostRoleError] = useState('');

  const [addHostRole, { loading }] = useMutation(
    AddUserHostRoleMutationDocument,
  );

  const { handleSubmit, register, reset } = useForm<AddUserHostRoleInput>({
    mode: 'onBlur',
    defaultValues: {
      role: HostRoleType.ADMIN,
      userID,
    },
  });

  const submitAddUserHostRoleForm = async (formData: AddUserHostRoleInput) => {
    const res = await addHostRole({
      variables: {
        input: formData,
      },
    });

    if (res.errors) {
      setAddingHostRoleError('Something went wrong while adding a new role!');
      return;
    }

    // reset form for new entry
    reset({
      role: HostRoleType.ADMIN,
      userID,
    });

    // notify parent
    onRoleAdded();
  };

  return (
    <Col className="p-1">
      <Row>
        <Col className="pt-3">
          <h4>Add Role(s)</h4>
        </Col>
      </Row>
      {addingHostRolesError && (
        <Row>
          <Col>
            <Alert variant="danger">{addingHostRolesError}</Alert>
          </Col>
        </Row>
      )}
      <Form role="form" onSubmit={handleSubmit(submitAddUserHostRoleForm)}>
        <Row>
          <Col className="pt-3">
            <Row>
              <Col>
                <Form.Group controlId="hostID">
                  <Form.Label>Host ID</Form.Label>
                  <Form.Control
                    {...register('hostID', { required: true })}
                    type="text"
                    required
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="role">
                  <Form.Label>Role</Form.Label>
                  <Form.Select {...register('role', { required: true })}>
                    <option key="ADMIN" value="ADMIN">
                      ADMIN
                    </option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col
                xs="12"
                md="auto"
                style={{ display: 'flex', alignItems: 'flex-end' }}
              >
                <div className="d-grid gap-2">
                  <SubmitButton
                    isSubmitting={loading}
                    text="Save"
                    submittingLabel="Saving ..."
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Col>
  );
}
